import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Parse from "parse";

import { useGame } from "../header/GameContext";
import { CHAT_DATA } from "../chat/chatData";
import Header from "../header/header";
import ChatBoxType2 from "../chat/chatType2";

import "./answer.css";

export default function Answer(props) {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    increaseMissionOnce,
    userRole,
    introInCodeV,
    isLastQuiz,
    correctCount,
    suspectScore,
    time,
    TOTAL_GAME_TIME,
  } = useGame();

  const [buttonData, setButtonData] = useState(null);

  const state = location.state || {};
  const { DateVal, missionKey, titImgClass, counting } = state;

  let answerData = "";
  if (isLastQuiz(DateVal)) {
    answerData = CHAT_DATA[DateVal];
  } else {
    answerData = CHAT_DATA[DateVal]["answer"];
  }

  let timerMode = DateVal !== "last_answer" ? "run" : "pause";

  const chatRef = useRef(null);
  const rawDateVal = DateVal;
  const isLast = rawDateVal === "last_q" || rawDateVal === "last_answer";

  useEffect(() => {
    if (!counting || !missionKey) return;
    if (isLast) return;
    increaseMissionOnce(missionKey);
  }, [counting, missionKey, increaseMissionOnce, isLast]);

  /* =========================
     버튼 클릭
  ========================= */
  const handleButtonClick = async () => {
    // console.log("🔍 DateVal:", DateVal, "isLastQuiz:", isLastQuiz(DateVal));
    setButtonData(null);

    if (isLastQuiz(DateVal)) {
      const objectId = localStorage.getItem("gameUserId");

      const finalQuizScore = correctCount * 10;
      const totalScore = finalQuizScore + suspectScore;

      // ✅ TOTAL_GAME_TIME은 localStorage의 ADMIN_TIME_KEY에서 직접 읽음
      // → syncTimer가 time을 바꿔도 관리자 설정 원래값은 유지됨
      const adminTime =
        Number(localStorage.getItem("ADMIN_TIME_KEY")) ||
        Number(TOTAL_GAME_TIME) ||
        0;
      const safeTime = Number(time) || 0;
      const usedTime = adminTime - safeTime; // 경과시간 = 원래시간 - 남은시간

      console.log("🏁 클리어 계산:", { adminTime, safeTime, usedTime });

      /* DB 저장 */
      try {
        if (objectId) {
          const GameUser = Parse.Object.extend("spyx");
          const query = new Parse.Query(GameUser);
          const user = await query.get(objectId);

          user.set("score", totalScore);
          user.set("clearTime", usedTime);
          await user.save();
        }
      } catch (e) {
        console.error("결과 저장 실패:", e);
      }

      /* 결과 페이지 이동 */
      navigate("/info", {
        state: {
          DateVal: "finish",
          titImgClass: "finishTit",
          score: totalScore,
          clearTime: usedTime,
        },
      });
    } else {
      navigate("/keywordInput");
    }
  };

  return (
    <div id="content">
      <Header />

      <div className="content_box1 ans0001">
        <div className="box box_con con_box1 con_pd5 con_box_c">
          <div className={`mission_tit ${titImgClass}`}></div>

          <ChatBoxType2
            DateVal={answerData}
            chatClass="chat_box6"
            onButton={setButtonData}
            timerMode={timerMode}
            ref={chatRef}
          />
        </div>

        {buttonData && (
          <div id="box_ft">
            <input
              type="button"
              className="inputBtn02 btnCode go_url_btn"
              value={buttonData.label}
              onClick={handleButtonClick}
            />
          </div>
        )}
      </div>
    </div>
  );
}
